// Услуги. Перенесены из Airtable (таблица «Услуги») в репозиторий.
// Правятся вручную: измените значения ниже и закоммитьте.
//   forServices — показывать в блоке «Услуги» (с иконкой)
//   forPrices   — показывать в блоке «Цены»
import { manikur, pedikur, french, gellak, ibx, kombi } from './icons'

export interface ServiceFields {
  Name: string
  Price: number
  Description: string
  forPrices: boolean
  forServices: boolean
  svgIcon?: string
}

export const services: { fields: ServiceFields }[] = [
  {
    fields: {
      Name: 'Аппаратный маникюр',
      Price: 30,
      Description:
        'Современная технология эффективной обработки ногтевой пластины и кутикулы, выполняемая с помощью специального аппарата с вращающимися насадками.',
      forPrices: true,
      forServices: true,
      svgIcon: manikur,
    },
  },
  {
    fields: {
      Name: 'Аппаратный педикюр',
      Price: 55,
      Description:
        'Это не только гигиеническая процедура по уходу за кожей и ногтями ног, но и целевые лечебные методики, применяемые для решения определенных медицинских проблем.',
      forPrices: true,
      forServices: true,
      svgIcon: pedikur,
    },
  },
  {
    fields: {
      Name: 'Французский маникюр',
      Price: 55,
      Description:
        'Эффективное и безболезненное укрепление ногтевой пластины гелем (процедура включает в себя маникюр, укрепление и покрытие гель-лаком)',
      forPrices: true,
      forServices: true,
      svgIcon: french,
    },
  },
  {
    fields: {
      Name: 'Покрытие гель-лаком',
      Price: 50,
      Description:
        'Покрытие, которое сможет защитить ваши ногти от различного рода повреждений, как механического, так и химического характера.',
      forPrices: true,
      forServices: true,
      svgIcon: gellak,
    },
  },
  {
    fields: {
      Name: 'Восстановление ногтей системой IBX',
      Price: 20,
      Description:
        'IBX – это первое лечебное средство для проблемных или ослабленных ногтей ( процедура включает в себя аппаратный маникюр + система IBX)',
      forPrices: true,
      forServices: true,
      svgIcon: ibx,
    },
  },
  {
    fields: {
      Name: 'Оформление бровей',
      Price: 25,
      Description:
        'Художественное оформление бровей (индивидуальный подбор формы и цвета, тридинг).',
      forPrices: true,
      forServices: false,
    },
  },
  {
    fields: {
      Name: 'Покраска ресниц',
      Price: 20,
      Description:
        'Окрашивание ресниц стойким составом — насыщенный цвет и выразительный взгляд без ежедневного макияжа.',
      forPrices: true,
      forServices: false,
    },
  },
  {
    fields: {
      Name: 'Комбинированный маникюр',
      Price: 30,
      Description:
        'Комбинированный маникюр сочетает в себе все лучшее от классического, европейского и аппаратного способов ухода за ногтями.',
      forPrices: true,
      forServices: true,
      svgIcon: kombi,
    },
  },
]
